import Phaser from 'phaser';
import { COLORS } from '@/config';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  create(): void {
    this.cameras.main.setBackgroundColor(COLORS.beige);
    this.scene.start('Preload');
  }
}
